var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('footer',[_c('div',{staticClass:"text-center bg-dark py-4"},[_c('small',{staticClass:"text-secondary"},[_vm._v("Copyright © 2023. Designed & Developed by "),_c('a',{attrs:{"href":"#"}},[_vm._v("Disnaker dan Diskominfo Kab. Konawe Selatan")])])])])])
}]

export { render, staticRenderFns }